import { AuthenticationService } from './../../admin/services/authentication.service';
import { MenuVisibiltyService } from '../services/role-menu.service';
import { Component, Input, OnInit, EventEmitter, ViewChild, Inject, forwardRef } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/primeng';
import { MainLayoutComponent } from '../layout/mainlayout.component';
import * as _ from 'lodash';


@Component({
    selector: 'app-menu',
    template: `
        <ul app-submenu [item]="model" root="true" class="ultima-menu ultima-main-menu clearfix" [reset]="reset" visible="true"></ul>
    `
})
export class AppMenuComponent implements OnInit {

    @Input() reset: boolean;

    model: MenuItem[];
    userInfo: any;


    constructor(@Inject(forwardRef(() => MainLayoutComponent)) public app: MainLayoutComponent,
        private authService: AuthenticationService,
        private menuGuardSrv: MenuVisibiltyService) { }


    ngOnInit() {
        this.model = [
            {
                label: 'Dashboard', icon: 'equalizer', routerLink: ['/'],
                // visible: this.menuGuardSrv.hideOrShow(['dashboard'])
            },

            // {
            //     label: 'Admin', icon: 'business',
            //     visible: this.menuGuardSrv.hideOrShow([
            //         'eod process',
            //         'api log',
            //         'app error log',
            //         'schedule simulation',
            //         'custom batch posting',
            //         'user group',
            //         'group activity',
            //         'staff registration',
            //         'user registration',
            //         'signature management',
            //         'user account management',
            //         'user-role setup',
            //         'profile-settings',
            //         'collateral type setup',
            //         'collateral sub-type setup',
            //         'accredited consultants',
            //         'approved employers setup',
            //         'approved fts markets setup',
            //         'limit maintenance',
            //         'email alert setup',
            //         'document repository setup',
            //         'checklist definition setup',
            //         'default conditions setup',
            //         'transaction dynamics setup',
            //         'compliance timeline setup',
            //         'covenant types setup',
            //         'prudential guidelines setup',
            //         'fs caption-group',
            //         'fs caption',
            //         'fs ratio-caption',
            //         'fs ratio-detail',
            //         'call limit setup',
            //         'job request setup',
            //         'group relationship type',
            //         'customer group',
            //         'group caption-detail',
            //         'approval group',
            //         'approval level',
            //         'approval workflow',
            //         'approval relief',
            //         'company setup',
            //         'region setup',
            //         'branch setup',
            //         'department setup',
            //         'unit setup',
            //         'state setup',
            //         'city setup',
            //         'tax setup',
            //         'fee and charge setup',
            //         'product process setup',
            //         'product class setup',
            //         'product group setup',
            //         'product type setup',
            //         'product definition setup',
            //         'product maintenance setup',
            //         'ledger account type',
            //         'chart of account',
            //         'approval trail',
            //         'dormant staff log',
            //         'deleted staff log',
            //         'bulk disbursement',
            //     ]),
            //     items: [
            //         {
            //             label: 'IT Admin', icon: '',
            //             visible: this.menuGuardSrv.hideOrShow([
            //                 'eod process',
            //                 'api log',
            //                 'app error log',
            //                 'custom batch posting',
            //                 'approval trail',
            //                 'dormant staff log',
            //                 'deleted staff log',
            //             ]),
            //             items: [
            //                 {
            //                     label: 'EOD Process', icon: '', routerLink: ['/setup/end-of-day'],
            //                     visible: this.menuGuardSrv.hideOrShow(['eod process'])
            //                 },
            //                 {
            //                     label: 'API Log', icon: '', routerLink: ['/admin/api-log'],
            //                     visible: this.menuGuardSrv.hideOrShow(['api log'])
            //                 },
            //                 {
            //                     label: 'Application Error Log', icon: '', routerLink: ['/admin/error-log'],
            //                     visible: this.menuGuardSrv.hideOrShow(['app error log'])
            //                 },
            //                 {
            //                     label: 'Deleted Staff Log', icon: '', routerLink: ['/admin/deleted-staff-log'],
            //                     visible: this.menuGuardSrv.hideOrShow(['deleted staff log'])
            //                 },
            //                 {
            //                     label: 'Dormant Staff Log', icon: '', routerLink: ['/admin/dormant-staff-log'],
            //                     visible: this.menuGuardSrv.hideOrShow(['dormant staff log'])
            //                 },
            //                 {
            //                     label: 'Custom Batch Posting', icon: '',
            //                     items: [
            //                         {
            //                             label: 'Detail', icon: '', routerLink: ['/admin/batch-posting-detail'],
            //                             visible: this.menuGuardSrv.hideOrShow(['schedule simulation'])
            //                         },
                                    
            //                         {
            //                             label: 'Main', icon: '', routerLink: ['/admin/batch-posting-main'],
            //                             visible: this.menuGuardSrv.hideOrShow(['schedule simulation'])
            //                         },
            //                         // {
            //                         //     label: 'Refresh Staging Monitoring', icon: '', routerLink: ['/admin/refresh-staging-monitoring'],
            //                         //     visible: this.menuGuardSrv.hideOrShow(['schedule simulation'])
            //                         // },
            //                         {
            //                             label: 'Refresh Staging Monitoring', icon: '', routerLink: ['/admin/refresh-staging-monitoring'],
            //                             visible: this.menuGuardSrv.hideOrShow(['schedule simulation'])
            //                         },
            //                     ]
            //                 }
            //             ]
            //         },
            //         {
            //             label: 'User Admin', icon: '',
            //             visible: this.menuGuardSrv.hideOrShow([
            //                 'user group',
            //                 'group activity',
            //                 'staff registration',
            //                 'user registration',
            //                 'signature management',
            //                 'user account management',
            //                 'user-role setup',
            //                 'profile-settings',
            //             ]),
            //             items: [
            //                 {
            //                     label: 'Groups', icon: '', routerLink: ['/admin/groups'],
            //                     visible: this.menuGuardSrv.hideOrShow(['user group'])
            //                 },
            //                 {
            //                     label: 'Group Activity', icon: '', routerLink: ['/admin/group-activity'],
            //                     visible: this.menuGuardSrv.hideOrShow(['group activity'])
            //                 },
            //                 {
            //                     label: 'Users', icon: '', routerLink: ['/admin/staff'],
            //                     visible: this.menuGuardSrv.hideOrShow(['staff registration'])
            //                 },

            //                 // {
            //                 //     label: 'Users', icon: '', routerLink: ['/admin/users'],
            //                 //     visible: this.menuGuardSrv.hideOrShow(['user registration'])
            //                 // },
            //                 {
            //                     label: 'User Role', icon: '', routerLink: ['/setup/staff-role'],
            //                     visible: this.menuGuardSrv.hideOrShow(['user-role setup'])
            //                 },

            //                 {
            //                     label: 'Credit Officer Risk Rating', icon: '', routerLink: ['/admin/officer-risk-rating'],
            //                     visible: this.menuGuardSrv.hideOrShow(['user account management'])
            //                 },

            //                 // {
            //                 //     label: 'Signature Management', icon: '', routerLink: ['/admin/staff/signature-management'],
            //                 //     visible: this.menuGuardSrv.hideOrShow(['signature management'])
            //                 // },
            //                 {
            //                     label: 'User Account Management', icon: '', routerLink: ['/admin/useradministration'],
            //                     visible: this.menuGuardSrv.hideOrShow(['user account management'])
            //                 },
            //                 // {
            //                 //     label: 'Staff/Supervisor Reporting', icon: '', routerLink: ['/setup/staff-supervisor-reporting'],
            //                 //     visible: this.menuGuardSrv.hideOrShow(['staff registration'])
            //                 // },
            //                 {
            //                     label: 'Profile Settings', icon: '', routerLink: ['/admin/profile-settings'],
            //                     visible: this.menuGuardSrv.hideOrShow(['profile-settings'])
            //                 },
            //                 // {
            //                 //     label: 'Staff/User Admin', icon: '',
            //                 //     visible: this.menuGuardSrv.hideOrShow([
            //                 //         'user group',
            //                 //         'group activity',
            //                 //         'staff registration',
            //                 //         'user registration',
            //                 //         'signature management',
            //                 //         'user account management',
            //                 //         'user-role setup',
            //                 //     ]),
            //                 //     items: [

            //                 //     ]
            //                 // },
            //             ]
            //         },
            //         {
            //             label: 'Credit Admin', icon: '',
            //             visible: this.menuGuardSrv.hideOrShow([
            //                 'collateral type setup',
            //                 'collateral sub-type setup',
            //                 'accredited consultants',
            //                 'approved employers setup',
            //                 'approved fts markets setup',
            //                 'limit maintenance',
            //                 'email alert setup',
            //                 'document repository setup',
            //                 'checklist definition setup',
            //                 'default conditions setup',
            //                 'transaction dynamics setup',
            //                 'compliance timeline setup',
            //                 'covenant types setup',
            //                 'prudential guidelines setup',
            //                 'fs caption-group',
            //                 'fs caption',
            //                 'fs ratio-caption',
            //                 'fs ratio-detail',
            //                 'call limit setup',
            //                 'job request setup',
            //                 'group relationship type',
            //                 'customer group',
            //                 'group caption-detail',
            //                 'approval group',
            //                 'approval level',
            //                 'approval workflow',
            //                 'approval relief',
            //                 'company setup',
            //                 'region setup',
            //                 'branch setup',
            //                 'department setup',
            //                 'unit setup',
            //                 'state setup',
            //                 'city setup',
            //               
            //             ]),
            //             items: [
            //                 {
            //                     label: 'Credit', icon: '',
            //                     visible: this.menuGuardSrv.hideOrShow([
            //                         'collateral type setup',
            //                         'collateral sub-type setup',
            //                         'accredited consultants',
            //                         'approved employers setup',
            //                         'approved fts markets setup',
            //                         'limit maintenance',
            //                         'email alert setup',
            //                         'document repository setup',
            //                         'checklist definition setup',
            //                         'default conditions setup',
            //                         'transaction dynamics setup',
            //                         'compliance timeline setup',
            //                         'covenant types setup',
            //                         'prudential guidelines setup',
            //                         'fs caption-group',
            //                         'fs caption',
            //                         'fs ratio-caption',
            //                         'fs ratio-detail',
            //                         'call limit setup',
            //                         'job request setup',
            //                         'document upload-setup',
            //                         'authoried signatories',
            //                         'insurance setup',

            //                     ]),
            //                     items: [
            //                         {
            //                             label: 'Collateral', icon: '',
            //                             visible: this.menuGuardSrv.hideOrShow(['collateral type setup', 'collateral sub-type setup']),
            //                             items: [
            //                                 {
            //                                     label: 'Types', icon: '', routerLink: ['/setup/collateral/collateral-type'],
            //                                     visible: this.menuGuardSrv.hideOrShow(['collateral type setup'])
            //                                 },
            //                                 {
            //                                     label: 'Sub-Types', icon: '', routerLink: ['/setup/collateral/collateral-sub-type'],
            //                                     visible: this.menuGuardSrv.hideOrShow(['collateral sub-type setup'])
            //                                 },
            //                             ],
            //                         },
            //                         {
            //                             label: 'Accredited Consultants', icon: '', routerLink: ['/setup/accredited-solicitors'],
            //                             visible: this.menuGuardSrv.hideOrShow(['accredited consultants'])
            //                         },
                                    
            //                         {
            //                             label: 'Accredited Principals', icon: '', routerLink: ['/setup/accredited-principals'],
            //                             visible: this.menuGuardSrv.hideOrShow(['accredited consultants'])
            //                         },
            //                         {
            //                             label: 'Approved Employers', icon: '', routerLink: ['/setup/setup/employer-setup'],
            //                             visible: this.menuGuardSrv.hideOrShow(['approved employers setup'])
            //                         },
            //                         {
            //                             label: 'Approved FTS Markets', icon: '', routerLink: ['/setup/credit/approved-market'],
            //                             visible: this.menuGuardSrv.hideOrShow(['approved fts markets setup'])
            //                         },
            //                         {
            //                             label: 'Limit Maintenance', icon: '', routerLink: ['/setup/limitmaintenance'],
            //                             visible: this.menuGuardSrv.hideOrShow(['limit maintenance'])
            //                         },
            //                         {
            //                             label: 'Email Alert', icon: '', routerLink: ['/setup/alertMessages'],
            //                             visible: this.menuGuardSrv.hideOrShow(['email alert setup'])
            //                         },
            //                         // {
            //                         //     label: 'Document Repository', icon: '', routerLink: ['/setup/document/document-template'],
            //                         //     visible: this.menuGuardSrv.hideOrShow(['document repository setup'])
            //                         // },
            //                         {
            //                             label: 'Document Template', icon: '', routerLink: ['/setup/document/document-template-setup'],
            //                             visible: this.menuGuardSrv.hideOrShow(['document template setup'])
            //                         },
            //                         {
            //                             label: 'Document Upload Setup', icon: '', routerLink: ['/setup/document/upload-setup'],
            //                             visible: this.menuGuardSrv.hideOrShow(['document upload setup'])
            //                         },
            //                         {
            //                             label: 'Reference Document', icon: '', routerLink: ['/setup/reference-document'],
            //                             visible: this.menuGuardSrv.hideOrShow(['document template setup'])
            //                         },
            //                         {
            //                             label: 'Checklist Definition', icon: '', routerLink: ['/setup/credit/checklist-definition'],
            //                             visible: this.menuGuardSrv.hideOrShow(['checklist definition setup'])
            //                         },
            //                         {
            //                             label: 'ESG Checklist Definition', icon: '', routerLink: ['/setup/credit/esg-checklist-definition'],
            //                             visible: this.menuGuardSrv.hideOrShow(['checklist definition setup'])
            //                         },
            //                         {
            //                             label: 'RAC', icon: '', routerLink: ['/setup/credit/rac'],
            //                             visible: this.menuGuardSrv.hideOrShow(['checklist definition setup'])
            //                         },
            //                         {
            //                             label: 'Compliance Timeline', icon: '', routerLink: ['/setup/credit/compliance-timeline'],
            //                             visible: this.menuGuardSrv.hideOrShow(['compliance timeline setup'])
            //                         },
            //                         {
            //                             label: 'Default Conditions', icon: '', routerLink: ['/setup/credit/condition-precedent'],
            //                             visible: this.menuGuardSrv.hideOrShow(['default conditions setup'])
            //                         },
            //                         {
            //                             label: 'Default Transaction Dynamics', icon: '', routerLink: ['/setup/credit/transaction-dynamics'],
            //                             visible: this.menuGuardSrv.hideOrShow(['transaction dynamics setup'])
            //                         },
            //                         {
            //                             label: 'Covenant Types', icon: '', routerLink: ['/setup/credit/covenant-type'],
            //                             visible: this.menuGuardSrv.hideOrShow(['covenant types setup'])
            //                         },
            //                         {
            //                             label: 'Prudential Guidelines', icon: '', routerLink: ['/setup/credit/prudential-guideline-setup'],
            //                             visible: this.menuGuardSrv.hideOrShow(['prudential guidelines setup'])
            //                         },
            //                         {
            //                             label: 'Authorised-Signatories', icon: '', routerLink: ['/setup/signatory/signatory-setup'],
            //                             visible: this.menuGuardSrv.hideOrShow(['Authorised Signatories'])
            //                         },
            //                         {
            //                             label: 'Insurance Setup', icon: '', routerLink: ['/setup/insurance-setup'],
            //                             visible: this.menuGuardSrv.hideOrShow(['Letter Generation Search'])
            //                         },
            //                         {
            //                             label: 'FS Caption', icon: '',
            //                             visible: this.menuGuardSrv.hideOrShow([
            //                                 'fs caption-group',
            //                                 'fs caption',
            //                                 'fs ratio-caption',
            //                                 'fs ratio-detail',
            //                             ]),
            //                             items: [
            //                                 {
            //                                     label: 'FS Caption-Group', icon: '',
            //                                     routerLink: ['/setup/credit/customer-fscaption-group'],
            //                                     visible: this.menuGuardSrv.hideOrShow(['fs caption-group'])
            //                                 },
            //                                 {
            //                                     label: 'FS Caption', icon: '',
            //                                     routerLink: ['/setup/credit/customer-fscaption'],
            //                                     visible: this.menuGuardSrv.hideOrShow(['fs caption'])
            //                                 },
            //                                 // {
            //                                 //     label: 'FS Ratio-Caption', icon: '',
            //                                 //     routerLink: ['/setup/credit/customer-fsratio-caption'],
            //                                 //     visible: this.menuGuardSrv.hideOrShow(['fs ratio-caption'])
            //                                 // },
            //                                 {
            //                                     label: 'FS Ratio-Detail', icon: '',
            //                                     routerLink: ['/setup/credit/customer-fsratio-detail'],
            //                                     visible: this.menuGuardSrv.hideOrShow(['fs ratio-detail'])
            //                                 },
            //                             ]
            //                         },
            //                         {
            //                             label: 'Call Limit', icon: '',
            //                             routerLink: ['/setup/credit/call-limit'],
            //                             visible: this.menuGuardSrv.hideOrShow(['call limit setup'])
            //                         },
            //                         {
            //                             label: 'Job Request Feedback', icon: '',
            //                             routerLink: ['/setup/credit/job-request-feedback'],
            //                             visible: this.menuGuardSrv.hideOrShow(['job request setup'])
            //                         },
            //                         {
            //                             label: 'Job Type Admin', icon: '',
            //                             routerLink: ['/setup/credit/job-type-admin'],
            //                             visible: this.menuGuardSrv.hideOrShow(['job request setup'])
            //                         },

            //                         {
            //                             label: 'Job Hub Management', icon: '',
            //                             routerLink: ['/setup/credit/job-hub-staff'],
            //                             visible: this.menuGuardSrv.hideOrShow(['job request status'])
            //                         },
            //                         {
            //                             label: 'Regulatory', icon: '',
            //                             visible: this.menuGuardSrv.hideOrShow(['collateral type setup', 'collateral sub-type setup']),
            //                             items: [
            //                                 {
            //                                     label: 'Regulatory Setup', icon: '', routerLink: ['/setup/regulatory/regulatory-setup'],
            //                                     visible: this.menuGuardSrv.hideOrShow(['collateral type setup'])
            //                                 },

            //                             ],
            //                         },
            //                     ]
            //                 },
            //                 {
            //                     label: 'Customer', icon: '',
            //                     visible: this.menuGuardSrv.hideOrShow([
            //                         'group relationship type',
            //                         'customer group',
            //                         'group caption-detail',
            //                     ]),
            //                     items: [
            //                         {
            //                             label: 'Group Relationship Type', icon: '', routerLink: ['/customer/customer-relationship-type'],
            //                             visible: this.menuGuardSrv.hideOrShow(['group relationship type'])
            //                         },
            //                         {
            //                             label: 'Customer Group', icon: '', routerLink: ['/customer/customer-group'],
            //                             visible: this.menuGuardSrv.hideOrShow(['customer group'])
            //                         },
            //                         // {
            //                         //     label: 'Caption-Detail (Group)', icon: '',
            //                         //     routerLink: ['/setup/credit/customer-group-fscaption-detail'],
            //                         //     visible: this.menuGuardSrv.hideOrShow(['group caption-detail'])
            //                         // },
            //                     ]
            //                 },
            //                 {
            //                     label: 'Approval', icon: '',
            //                     visible: this.menuGuardSrv.hideOrShow([
            //                         'approval group',
            //                         'approval level',
            //                         'approval workflow',
            //                         'approval relief',
            //                     ]),
            //                     items: [
            //                         {
            //                             label: 'Group', icon: '', routerLink: ['/setup/approval-group'],
            //                             visible: this.menuGuardSrv.hideOrShow(['approval group'])
            //                         },
            //                         {
            //                             label: 'Level', icon: '', routerLink: ['/setup/approval-level'],
            //                             visible: this.menuGuardSrv.hideOrShow(['approval level'])
            //                         },
            //                         {
            //                             label: 'Workflow', icon: '', routerLink: ['/setup/approval-workflow'],
            //                             visible: this.menuGuardSrv.hideOrShow(['approval workflow'])
            //                         },
            //                         {
            //                             label: 'Relief', icon: '', routerLink: ['/setup/approval-relief'],
            //                             visible: this.menuGuardSrv.hideOrShow(['approval relief'])
            //                         },
            //                         {
            //                             label: 'Rule', icon: '', routerLink: ['/setup/approval-level-rule'],
            //                             visible: this.menuGuardSrv.hideOrShow(['approval level'])
            //                         },
            //                         {
            //                             label: 'Workflow Change', icon: '', routerLink:['/setup/approval-workflowchange'],
            //                             visible:this.menuGuardSrv.hideOrShow(['approval workflow'])
            //                         },

            //                     ]
            //                 },
            //                 {
            //                     label: 'Location', icon: '',
            //                     visible: this.menuGuardSrv.hideOrShow([
            //                         'company setup',
            //                         'region setup',
            //                         'branch setup',
            //                         'department setup',
            //                         'unit setup',
            //                         'state setup',
            //                         'city setup',
            //                     ]),
            //                     items: [
            //                         {
            //                             label: 'Company', icon: '', routerLink: ['/setup/company'],
            //                             visible: this.menuGuardSrv.hideOrShow(['company setup'])
            //                         },
            //                         {
            //                             label: 'Region', icon: '', routerLink: ['/setup/region'],
            //                             visible: this.menuGuardSrv.hideOrShow(['region setup'])
            //                         },
            //                         {
            //                             label: 'Branch', icon: '', routerLink: ['/setup/branch'],
            //                             visible: this.menuGuardSrv.hideOrShow(['branch setup'])
            //                         },
            //                         {
            //                             label: 'Department', icon: '', routerLink: ['/setup/department'],
            //                             visible: this.menuGuardSrv.hideOrShow(['department setup'])
            //                         },
            //                         {
            //                             label: 'Unit', icon: '', routerLink: ['/setup/units'],
            //                             visible: this.menuGuardSrv.hideOrShow(['unit setup'])
            //                         },
            //                         {
            //                             label: 'Local Govt', icon: '', routerLink: ['/setup/local-govt'],
            //                             visible: this.menuGuardSrv.hideOrShow(['state setup'])
            //                         },
            //                         {
            //                             label: 'State', icon: '', routerLink: ['/setup/state'],
            //                             visible: this.menuGuardSrv.hideOrShow(['state setup'])
            //                         },
            //                         {
            //                             label: 'City', icon: '', routerLink: ['/setup/cities'],
            //                             visible: this.menuGuardSrv.hideOrShow(['city setup'])
            //                         },
            //                     ]
            //                 },
            //             ]
            //         },
            //         {
            //             label: 'FINCON Admin', icon: '',
            //             visible: this.menuGuardSrv.hideOrShow([
            //                 'tax setup',
            //                 'fee and charge setup',
            //                 'product process setup',
            //                 'product class setup',
            //                 'product group setup',
            //                 'product type setup',
            //                 //'product definition setup',
            //                 'product maintenance setup',
            //                 'ledger account type',
            //                 'chart of account'
            //             ]),
            //             items: [

            //                 {
            //                     label: 'Fee and Charge Setup', icon: '',
            //                     visible: this.menuGuardSrv.hideOrShow(['tax setup', 'fee and charge setup']),
            //                     items: [
            //                         // {
            //                         //     label: 'Tax', icon: '', routerLink: ['/setup/charge/tax'],
            //                         //     visible: this.menuGuardSrv.hideOrShow(['tax setup'])
            //                         // },
            //                         {
            //                             label: 'Fees/Charges', icon: '', routerLink: ['/setup/charge/charge'],
            //                             visible: this.menuGuardSrv.hideOrShow(['fee and charge setup'])
            //                         },

            //                     ]
            //                 },
            //                 {
            //                     label: 'Product', icon: '',
            //                     visible: this.menuGuardSrv.hideOrShow([
            //                         'product process setup',
            //                         'product class setup',
            //                         'product group setup',
            //                         'product type setup',
            //                         'product definition setup',
            //                         'product maintenance setup',
            //                         'document definition setup',
            //                         'document mapping setup'

            //                     ]),
            //                     items: [
            //                         {
            //                             label: 'Process', icon: '', routerLink: ['/setup/product/product-process'],
            //                             visible: this.menuGuardSrv.hideOrShow(['product process setup'])
            //                         },
            //                         {
            //                             label: 'Class', icon: '', routerLink: ['/setup/product/product-class'],
            //                             visible: this.menuGuardSrv.hideOrShow(['product class setup'])
            //                         },
            //                         {
            //                             label: 'Group', icon: '', routerLink: ['/setup/product/product-group'],
            //                             visible: this.menuGuardSrv.hideOrShow(['product group setup'])
            //                         },
            //                         {
            //                             label: 'Type', icon: '', routerLink: ['/setup/product/product-type'],
            //                             visible: this.menuGuardSrv.hideOrShow(['product type setup'])
            //                         },
            //                         {
            //                             label: 'Definition', icon: '', routerLink: ['/setup/product/product-definition'],
            //                             visible: this.menuGuardSrv.hideOrShow(['product definition setup'])
            //                         },
            //                         // {
            //                         //     label: 'Document Definition', icon: '', routerLink: ['/setup/product/document-definition'],
            //                         //     visible: this.menuGuardSrv.hideOrShow(['document definition setup'])
            //                         // },
            //                         {
            //                             label: 'Product Document Mapping', icon: '', routerLink: ['/setup/product/document-mapping'],
            //                             visible: this.menuGuardSrv.hideOrShow(['document mapping setup'])
            //                         },
            //                         {
            //                             label: 'Maintenance', icon: '', routerLink: ['/setup/product/product-maintenance'],
            //                             visible: this.menuGuardSrv.hideOrShow(['product maintenance setup'])
            //                         },
            //                         {
            //                             label: 'Price Index', icon: '', routerLink: ['/setup/product/product-price-index'],
            //                             visible: this.menuGuardSrv.hideOrShow(['product definition setup'])
            //                         }
            //                     ]
            //                 },

            //                 {
            //                     label: 'Finance', icon: '',
            //                     visible: this.menuGuardSrv.hideOrShow(['ledger account type', 'chart of account']),
            //                     items: [
            //                         {
            //                             label: 'Ledger Account Type', icon: '', routerLink: ['/setup/finance/ledger'],
            //                             visible: this.menuGuardSrv.hideOrShow(['ledger account type'])
            //                         },
            //                         {
            //                             label: 'Chart of Account', icon: '', routerLink: ['/setup/finance/account-chart'],
            //                             visible: this.menuGuardSrv.hideOrShow(['chart of account'])
            //                         },
            //                         {
            //                             label: 'Custom Chart of Account', icon: '', routerLink: ['/setup/finance/custom-account-chart'],
            //                             visible: this.menuGuardSrv.hideOrShow(['chart of account'])
            //                         },
            //                     ]
            //                 },
            //             ]
            //         },
            //         {
            //             label: 'Bulk Disbursement', icon: '', routerLink: ['/admin/bulk-disbursement'],
            //             visible: this.menuGuardSrv.hideOrShow(['bulk disbursement'])
            //         },
            //     ]
            // },

            // {
            //     label: 'Setup', icon: 'build',
            //     visible: this.menuGuardSrv.hideOrShow([
            //         'collateral type setup',
            //         'collateral sub-type setup',
            //         'accredited consultants',
            //         'approved employers setup',
            //         'approved fts markets setup',
            //         'limit maintenance',
            //         'email alert setup',
            //         'document repository setup',
            //         'checklist definition setup',
            //         'default conditions setup',
            //         'transaction dynamics setup',
            //         'compliance timeline setup',
            //         'covenant types setup',
            //         'prudential guidelines setup',
            //         'fs caption-group',
            //         'fs caption',
            //         'group caption-detail',
            //         'fs ratio-caption',
            //         'fs ratio-detail',
            //         'call limit setup',
            //         'job request setup',
            //         'product process setup',
            //         'product class setup',
            //         'product group setup',
            //         'product type setup',
            //         'product definition setup',
            //         'product maintenance setup',
            //         'group relationship type',
            //         'customer group',
            //         'company setup',
            //         'region setup',
            //         'branch setup',
            //         'department setup',
            //         'unit setup',
            //         'state setup',
            //         'city setup',
            //         'approval group',
            //         'approval level',
            //         'approval workflow',
            //         'approval relief',
            //     ]),
            //     items: [


            //         //
            //         //     label: 'Risk', icon: '',
            //         //     visible: this.menuGuardSrv.hideOrShow(['risk index', 'risk scoring']),
            //         //     items: [
            //         //         {
            //         //             label: 'Index', icon: '', routerLink: ['/setup/risk/risk-index'],
            //         //             visible: this.menuGuardSrv.hideOrShow(['risk index'])
            //         //         },
            //         //         {
            //         //             label: 'Scoring', icon: '', routerLink: ['/setup/risk/risk-scoring'],
            //         //             visible: this.menuGuardSrv.hideOrShow(['risk scoring'])
            //         //         },
            //         //     ]
            //         // },
            //     ]
            // },
            // {
            //     label: 'Customer Management', icon: 'account_box',
            //     visible: this.menuGuardSrv.hideOrShow([
            //         'customer profile',
            //         'casa search',
            //         'customer caption-detail',
            //         'view financial statement',
            //     ]),
            //     items: [
            //         {
            //             label: 'Customer Profile', icon: '', routerLink: ['/customer/customer-information'],
            //             visible: this.menuGuardSrv.hideOrShow(['customer profile'])
            //         },
            //         {
            //             //label: 'Update Prospect Information', icon: '', routerLink: ['/customer/prospect-customer'],
            //             label: 'Convert Prospect To Customer', icon: '', routerLink: ['/customer/prospect-customer'],
            //             visible: this.menuGuardSrv.hideOrShow(['customer profile'])
            //         },
            //         // {
            //         //     label: 'CASA Search', icon: '', routerLink: ['/customer/casa'],
            //         //     visible: this.menuGuardSrv.hideOrShow(['casa search'])
            //         // },
            //         {
            //             label: 'Financial Caption (Customer)', icon: '', routerLink: ['/setup/credit/customer-fscaption-detail'],
            //             visible: this.menuGuardSrv.hideOrShow(['customer caption-detail'])
            //         },
            //         {
            //             label: 'Caption-Detail (Group)', icon: '',
            //             routerLink: ['/setup/credit/customer-group-fscaption-detail'],
            //             visible: this.menuGuardSrv.hideOrShow(['group caption-detail'])
            //         },
            //         {
            //             label: 'View Financial Statement', icon: '', routerLink: ['/setup/credit/view-financial-statement'],
            //             visible: this.menuGuardSrv.hideOrShow(['view financial statement'])
            //         },
            //     ]
            // },
            {
                label: 'Approvals', icon: 'check_circle',
                visible: this.authService.verifyCorr() && this.menuGuardSrv.hideOrShow([
                    // 'approval trail',
                    // 'customer profile approval',
                    // 'user setup approval',
                    // 'user-role setup approval',
                    // 'product setup approval',
                    // 'chart of account setup approval',
                    // 'customer group setup approval',
                    'aps approval',
                    // 'loan disbursment',
                    // 'booking verifier',
                    // 'loan recovery payment',
                    'drawdown approval',
                    'tranche disbursement approval',
                    'Adhoc Approval',
                    'exceptional loan approval'
                    // 'checklist deferral approval',
                    // 'concession approval',
                    // 'pen approval',
                    // 'override approval',
                    // 'reasigned accounts approval',
                    // 'credit operations approval',
                    // 'collateral approval',
                    // 'collateral policy approval',
                    // 'collateral assignment approval',
                    // 'collateral release approval',
                    // 'Lc Issuance Approval',
                    // 'Release Of Shipping Documents Approval',
                    // 'Lc Ussance Approval',
                    // 'ATC Lodgement Approval',
                    // 'ATC Release Approval',
                    // 'Project Site Report Approval',
                    // 'Letter Generation Request Approval',
                    // 'security release approval',
                    // 'collateral valuation approval',
                    // 'security-release-approval',
                    // 'call-memo approval'
                ]),
                items: [
                    // {
                    //     label: 'Approval Trail', icon: '', routerLink: ['/admin/audit-trail'],
                    //     visible: this.menuGuardSrv.hideOrShow(['approval trail'])
                    // },
                  
                    {
                        label: 'Credit', icon: '',
                        visible: this.menuGuardSrv.hideOrShow([
                            'aps approval',
                            'loan disbursment',
                            'booking verifier',
                            'loan recovery payment',
                            'drawdown approval',
                            'tranche disbursement approval',
                            'checklist deferral approval',
                            'concession approval',
                            'pen approval',
                            'override approval',
                            'reasigned accounts approval',
                            'credit operations approval',
                            'Lc Issuance Approval',
                            'Release Of Shipping Documents Approval',
                            'Lc Ussance Approval',
                            'Original Document Approval',
                            'ATC Lodgement Approval',
                            'ATC Release Approval',
                            'Project Site Report Approval',
                            'Letter Generation Request Approval',
                            'security release approval',
                            'call memo approval',
                            'Adhoc Approval',
                            'exceptional loan approval'
                        ]),
                        items: [
                            // {
                            //     label: 'APS', icon: '', routerLink: ['/approvals/credit/advance-payment-sum-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['aps approval'])
                            // },
                            {
                                label: 'Drawdown Approval', icon: '', routerLink: ['/approvals/credit/tranche-booking'],
                                visible: this.menuGuardSrv.hideOrShow(['drawdown approval'])
                            },
                            // {
                            //     label: 'Booking Verification', icon: '', routerLink: ['/approvals/credit/loan-booking-verification'],
                            //     visible: this.menuGuardSrv.hideOrShow(['booking verifier'])
                            // },
                            // {
                            //     label: 'Loan Recovery Payment', icon: '', routerLink: ['/credit/loan-management/loan-recovery-repayment-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['loan recovery payment'])
                            // },
                            // {
                            //     label: 'Disbursement', icon: '', routerLink: ['/approvals/credit/loan-disbursement'],
                            //     visible: this.menuGuardSrv.hideOrShow(['loan disbursment'])
                            // }, 
                            // {
                            //     label: 'Multiple Disbursement ', icon: '', routerLink: ['/approvals/credit/bulk-loan-disbursement-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['loan disbursment'])
                            // }, 
                            // {
                            //     label: 'B & G Release Approval', icon: '', routerLink: ['/approvals/credit/loan-booking'],
                            //     visible: this.menuGuardSrv.hideOrShow(['bonds and guarantee'])
                            // },
                            {
                                label: 'Adhoc Approval', icon: '', routerLink: ['/approvals/credit/adhoc-approvals'],
                                visible: this.menuGuardSrv.hideOrShow(['Adhoc Approval'])
                            },

                            {
                                label: 'Exceptional Loan', icon: '', routerLink: ['/approvals/credit/exceptional-loan-approval'],
                                visible: this.menuGuardSrv.hideOrShow(['exceptional loan approval'])
                            },

                            // {
                            //     label: 'Letter Of Credit Approvals', icon: '',
                            //     visible: this.menuGuardSrv.hideOrShow(['Lc Issuance Approval', 'Release Of Shipping Documents Approval', 'Lc Ussance Approval']),
                            //     items: [
                            //         {
                            //             label: 'LC Issuance Approval', icon: '', routerLink: ['/credit/lc/issuance-approval'],
                            //             visible: this.menuGuardSrv.hideOrShow(['Lc Issuance Approval'])
                            //         },
                            //         {
                            //             label: 'Release Of Shipping Documents Approval', icon: '', routerLink: ['/credit/lc/release-approval'],
                            //             visible: this.menuGuardSrv.hideOrShow(['Release Of Shipping Documents Approval'])
                            //         },
                            //         {
                            //             label: 'LC Usance Approval', icon: '', routerLink: ['/credit/lc/ussance-approval'],
                            //             visible: this.menuGuardSrv.hideOrShow(['Lc Ussance Approval'])
                            //         }
                            //     ]
                            // },
                            // {
                            //     label: 'Letter Generation Request Approval', icon: '', routerLink: ['/approvals/letter-generation-request-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['Letter Generation Request Approval'])
                            // },
                            // {
                            //     label: 'Deferral/Waiver Approvals', icon: '', routerLink: ['/approvals/credit/checklist-deferral-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['checklist deferral approval'])
                            // },
                            // {
                            //     label: 'Fee/Rate Concession', icon: '', routerLink: ['/approvals/credit/fee-concession-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['concession approval'])
                            // },
                            //                             {
                            // // tslint:disable-next-line: max-line-length
                            //                                 label: 'Preliminary Evaluation Note', icon: '', routerLink: ['/approvals/credit/preliminary-evaluation-note'],
                            //                                 visible: this.menuGuardSrv.hideOrShow(['pen approval'])
                            //                             },
                            // {
                            //     label: 'Override', icon: '', routerLink: ['/approvals/credit/override-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['override approval'])
                            // },
                            // {
                            //     label: 'Reasigned Accounts', icon: '', routerLink: ['/approvals/credit/reasign-account'],
                            //     visible: this.menuGuardSrv.hideOrShow(['reasigned accounts approval'])
                            // },
                            // {
                            //     label: 'Credit Operations', icon: '', routerLink: ['/approvals/credit/loan-restructuring'],
                            //     visible: this.menuGuardSrv.hideOrShow(['credit operations approval'])
                            // },
                            // {
                            //     label: 'Line Operations', icon: '', routerLink: ['/approvals/credit/line-operation-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['credit operations approval'])
                            // },
                            // {
                            //     label: 'Commercial Loan Operations', icon: '', routerLink: ['/approvals/credit/commercial-loan-operations-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['credit operations approval'])
                            // },
                            // {
                            //     label: 'Written-off Accounts/Black-Book', icon: '', routerLink: ['/approvals/credit/camsol-blackbook'],
                            //     visible: this.menuGuardSrv.hideOrShow(['credit operations approval'])
                            // },
                            // {
                            //     label: 'Loan Application Cancellation', icon: '', routerLink: ['/approvals/loan-application-cancellation'],
                            //     visible: this.menuGuardSrv.hideOrShow(['aps approval'])
                            // },

                            // {
                            //     label: 'Accredited Solicitors Approval', icon: '', routerLink: ['/approvals/accredited-solicitors-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['customer group setup approval'])
                            // },
                            // {
                            //     label: 'Manual Fee Approval', icon: '', routerLink: ['/approvals/credit/take-fee-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['manual fee approval'])
                            // },
                            // {
                            //     label: 'Global Interest Rate Change', icon: '', routerLink: ['/approvals/credit/global-interest-rate-change-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['global interest rate change'])
                            // },
                            // {
                            //     label: 'Original Document Approval', icon: '', routerLink: ['/approvals/credit/original-document-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['Original Document Approval'])
                            // },
                            // {
                            //     label: 'ATC Lodgement Approval', icon: '', routerLink: ['/approvals/credit/atc-lodgement-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['ATC Lodgement Approval'])
                            // },
                            // {
                            //     label: 'ATC Release Approval', icon: '', routerLink: ['/approvals/credit/app-atc-release-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['ATC Release Approval'])
                            // },
                            // {
                            //     label: 'Project Site Report Approval', icon: '', routerLink: ['/approvals/project-site-report-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['Project Site Report Approval'])
                            // },
                            // {
                            //     label: 'Collateral Valuation Approval', icon: '', routerLink: ['/approvals/collateral-valuation-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['collateral valuation approval'])
                            // },
                            // {
                            //     label: 'Security Release Approval', icon: '', routerLink: ['/approvals/security-release-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['security release approval'])
                            // },
                            // {
                            //     label: 'Call Memo Approval', icon: '', routerLink: ['/approvals/call-memo-approval'],
                            //     visible: this.menuGuardSrv.hideOrShow(['call memo approval'])
                            // }
                        ]
                    },
                    // {
                    //     label: 'Collateral', icon: '',
                    //     visible: this.menuGuardSrv.hideOrShow([
                    //         'collateral approval',
                    //         'collateral policy approval',
                    //         'collateral assignment approval',
                    //         'collateral release approval'
                    //     ]),
                    //     items: [
                    //         {
                    //             label: 'Collateral Management', icon: '', routerLink: ['/approvals/credit/collateral-management-approval'],
                    //             visible: this.menuGuardSrv.hideOrShow(['collateral approval'])
                    //         },
                    //         {
                    //             label: 'Collateral Insurance Policy', icon: '', routerLink: ['/approvals/credit/collateral-item-policy-approval'],
                    //             visible: this.menuGuardSrv.hideOrShow(['collateral policy approval'])
                    //         },
                    //         {
                    //             label: 'Collateral Assignment', icon: '', routerLink: ['/approvals/credit/collateral-assignment-approval'],
                    //             visible: this.menuGuardSrv.hideOrShow(['collateral assignment approval'])
                    //         },
                    //         {
                    //             label: 'Collateral Release', icon: '', routerLink: ['/approvals/credit/collateral-release-approval'],
                    //             visible: this.menuGuardSrv.hideOrShow(['collateral release approval'])
                    //         },
                    //         {
                    //             label: 'Collateral Info Release', icon: '', routerLink: ['/approvals/credit/collateral-information-release-approval'],
                    //             visible: this.menuGuardSrv.hideOrShow(['collateral release approval'])
                    //         },
                    //     ]
                    // },

                ]
            },

            // {
            //     label: 'Job Request', icon: 'account_box',
            //     visible: this.menuGuardSrv.hideOrShow([
            //         'job request status',

            //     ]),
            //     items: [
            //         {
            //             label: 'Job Request Status', icon: '', routerLink: ['/credit/credit-job-request'],
            //             visible: this.menuGuardSrv.hideOrShow(['job request status'])
            //         },
            //         {
            //             label: 'Facility Job Request', icon: '', routerLink: ['/credit/facility-job-request'],
            //             visible: this.menuGuardSrv.hideOrShow(['confirm collateral search'])
            //         },
            //         {
            //             label: 'Confirm Collateral Search', icon: '', routerLink: ['/credit/legal-job-request-confirmation'],
            //             visible: this.menuGuardSrv.hideOrShow(['confirm collateral search'])
            //         },
            //     ]
            // },

            {
                label: 'Credit', icon: 'account_balance_wallet',
                visible: this.authService.verifyCorr() && this.menuGuardSrv.hideOrShow([
                    'repayment schedule simulation',
                    'start credit application',
                    'credit applications',
                    'credit application status',
                    'bonds and guarantee',
                    'rejected applications',
                    'loan fee concessions',
                    'deferral management',
                    'preliminary evaluation notes',
                    'application route',
                    'credit appraisal',
                    'committee secretariat',
                    'generate offer letter',
                    'review offer letter',
                    'availment',
                    'booking request',
                    'booking',
                    'call memo',
                    'job request status',
                    'confirm collateral search',
                    'override request',
                    'lms application',
                    'lms appraisal',
                    'lms generate offer letter',
                    'lms availment',
                    'loan operations',
                    'overdraft operations',
                    'recovery operations',
                    'contingent operations',
                    'loan operations',
                    'loan operations',
                    'recovery payment plan',
                    'prepayment',
                    'aps request',
                    'reassign account',
                    'collateral information',
                    'collateral assignment',
                    ' covenant maintenance',
                    'risk assessment',
                    'facility detail summary',
                    'credit classification',
                    'fee charge change',
                    'maturity instruction',
                    'commercial loan rollover',
                    'commercial loan tenor extension',
                    'commercial loan sub-allocation',
                    'commercial loan rate review',
                    'commercial loan prepayment',
                    'availmant route',
                    'risk assessment',
                    'deferral management',
                    'Original Document',
                    'security release'


                ]),
                items: [
                    {
                        label: 'Credit Origination', icon: '',
                        visible: this.menuGuardSrv.hideOrShow([
                            'repayment schedule simulation',
                            'start credit application',
                            'credit applications',
                            'credit application status',
                            'drawdown application status',
                            'bonds and guarantee',
                            'rejected applications',
                            'loan fee concessions',
                            'deferral management',
                            'preliminary evaluation notes',
                            'application route',
                            'credit appraisal',
                            'committee secretariat',
                            'generate offer letter',
                            'review offer letter',
                            'availment',
                            'booking request',
                            'booking',
                            'call memo',
                            'job request status',
                            'confirm collateral search',
                            'override request',
                            'availmant route',
                            'term sheet',
                            'Release Of Shipping Documents',
                            'Lc Issuance',
                            'Lc Ussance',
                            'Letter Generation Request',
                            'Letter Generation Completed',
                            'letter generation search',
                            'security release'

                        ]),
                        items: [
                    //         // {
                    //         //     label: 'MAP', icon: '', routerLink: ['/credit/loan/map'],
                    //         //     visible: this.menuGuardSrv.hideOrShow(['schedule simulation'])
                    //         // },
                    //         {
                    //             label: 'Document Search', icon: '', routerLink: ['/credit/loan/document-Search'],
                    //             visible: this.menuGuardSrv.hideOrShow([
                    //                 'start credit application',
                    //                 'credit applications',
                    //                 'credit appraisal',
                    //                 'booking request',
                    //                 'booking',
                    //                 'generate offer letter',
                    //                 'review offer letter',
                    //                 'Original Document',
                    //                 'ATC Lodgement',
                    //                 'ATC Release',
                    //                 'Project Site Report'
                    //             ])
                    //         },

                    //         {
                    //             label: 'ATC Lodgement', icon: '', routerLink: ['/credit/loan/atc-lodgment'],
                    //             visible: this.menuGuardSrv.hideOrShow(['ATC Lodgement'])
                    //         },
                    //         {
                    //             label: 'ATC Release', icon: '', routerLink: ['/credit/loan/atc-release'],
                    //             visible: this.menuGuardSrv.hideOrShow(['ATC Release'])
                    //         },
                    //         {
                    //             label: 'Disbursed Loans', icon: '', routerLink: ['/credit/loan/disbursed-loans'],
                    //             visible: this.menuGuardSrv.hideOrShow([
                    //                 'loan disbursment',
                    //                 'booking request',
                    //                 'booking',
                    //             ])
                    //         },
                    //         {
                    //             label: 'Loan Fee Schedule', icon: '', routerLink: ['/credit/loan/loan-fee-schedule'],
                    //             visible: this.menuGuardSrv.hideOrShow([
                    //                 'start credit application',
                    //                 'credit applications',
                    //                 'credit appraisal',
                    //                 'booking request',
                    //                 'booking',
                    //                 'schedule simulation',
                    //                 'loan disbursment',
                    //                 // 'project-site-report'
                    //             ])
                    //         },
                    //         {
                    //             label: 'Repayment Schedule Simulation', icon: '', routerLink: ['/credit/loan/schedule'],
                    //             visible: this.menuGuardSrv.hideOrShow(['schedule simulation'])
                    //         },
                    //         {
                    //             label: 'View Product Checklist', icon: '', routerLink: ['/credit/loan/checklist-simulation'],
                    //             visible: this.menuGuardSrv.hideOrShow(['schedule simulation'])
                    //         },
                    //         {
                    //             label: 'Letter Of Credit', icon: '',
                    //             visible: this.menuGuardSrv.hideOrShow(['Lc Issuance', 'Release Of Shipping Documents', 'Lc Ussance',
                    //                 'Lc Issuance Approval',
                    //                 'Release Of Shipping Documents Approval',
                    //                 'Lc Ussance Approval',
                    //             ]),
                    //             items: [
                    //                 {
                    //                     label: 'LC Search', icon: '', routerLink: ['/credit/lc/search'],
                    //                     visible: this.menuGuardSrv.hideOrShow([
                    //                         'Release Of Shipping Documents',
                    //                         'Lc Issuance',
                    //                         'Lc Ussance',
                    //                         'Lc Issuance Approval',
                    //                         'Release Of Shipping Documents Approval',
                    //                         'Lc Ussance Approval',
                    //                     ])
                    //                 },
                    //                 {
                    //                     label: 'LC Issuance', icon: '', routerLink: ['/credit/lc/issuance'],
                    //                     visible: this.menuGuardSrv.hideOrShow(['Lc Issuance'])
                    //                 },
                    //                 {
                    //                     label: 'Release Of Shipping Document', icon: '', routerLink: ['/credit/lc/release-shipping-documents'],
                    //                     visible: this.menuGuardSrv.hideOrShow(['Release Of Shipping Documents'])
                    //                 },
                    //                 {
                    //                     label: 'LC Ussance', icon: '', routerLink: ['/credit/lc/ussance'],
                    //                     visible: this.menuGuardSrv.hideOrShow(['Lc Ussance'])
                    //                 }
                    //             ]
                    //         },
                    //         {
                    //             label: 'Letter Generation Request', icon: '', routerLink: ['/credit/letter-generation-request'],
                    //             visible: this.menuGuardSrv.hideOrShow(['Letter Generation Request'])
                    //         },
                    //         {
                    //             label: 'Letter Generation Search', icon: '', routerLink: ['/setup/letter-generation-search'],
                    //             visible: this.menuGuardSrv.hideOrShow(['Letter Generation Completed',
                    //                                                     'Letter Generation Request',
                    //                                                     'Letter Generation Request Approval'])
                    //         },
                    //         {
                    //             label: 'Letter Generation Completed', icon: '', routerLink: ['/credit/letter-generation-completed'],
                    //             visible: this.menuGuardSrv.hideOrShow(['Letter Generation Completed',
                    //                                                     'Letter Generation Request',
                    //                                                     'Letter Generation Request Approval'])
                    //         },
                            {
                                label: 'Start Credit Application', icon: '', routerLink: ['/credit/loan/application/start'],
                                visible: this.menuGuardSrv.hideOrShow(['start credit application'])
                            },
                            {
                                label: 'Credit Applications', icon: '', routerLink: ['/credit/loan/loan-application-list'],
                                visible: this.menuGuardSrv.hideOrShow(['credit applications'])
                            },
                                {
                                    label: 'Credit Application Status', icon: '', routerLink: ['/credit/loan/application-search'],
                                    visible: this.menuGuardSrv.hideOrShow(['credit application status'])
                                },
                                {
                                    label: 'DrawDown Application Status', icon: '', routerLink: ['/credit/loan/drawdown-search'],
                                    visible: this.menuGuardSrv.hideOrShow(['credit application status'])
                                },
                                {
                                    label: 'Rejected Applications', icon: '', routerLink: ['/credit/loan/rejected-application'],
                                     visible: this.menuGuardSrv.hideOrShow(['rejected applications'])
                                  },
                    //         // {
                    //         //     label: 'Bonds and Guarantee', icon: '', routerLink: ['/credit/loan/bonds-and-guarantee'],
                    //         //     visible: this.menuGuardSrv.hideOrShow(['bonds and guarantee'])
                    //         // },
                    //         {
                    //             label: 'Loan Fee Concessions', icon: '', routerLink: ['/credit/loan/application/fee-concession'],
                    //             visible: this.menuGuardSrv.hideOrShow(['loan fee concessions'])
                    //         },

                    //         // {
                    //         //     label: 'Routing', icon: '',
                    //         //     visible: this.menuGuardSrv.hideOrShow([
                    //         //         'application route',
                    //         //         'availment route',
                    //         //     ]),
                    //         //     items: [
                    //         // {
                    //         //     label: 'Preliminary Evaluation Notes', icon: '', routerLink: ['/credit/loan/preliminary-evaluation/view'],
                    //         //     visible: this.menuGuardSrv.hideOrShow(['preliminary evaluation notes'])
                    //         // },
                    //         // {
                    //         //     label: 'Routing', icon: '',
                    //         //     visible: this.menuGuardSrv.hideOrShow([
                    //         //         'application route',
                    //         //         'availment route',
                    //         //     ]),
                    //         //     items: [
                    //         {
                    //             label: 'Application Route', icon: '', routerLink: ['/credit/appraisal/sla-monitoring'],
                    //             visible: this.menuGuardSrv.hideOrShow(['application route'])
                    //         },
                    //         // {
                    //         //     label: 'Availment Route', icon: '', routerLink: ['/credit/appraisal/availment-route'],
                    //         //     visible: this.menuGuardSrv.hideOrShow(['availment route'])
                    //         // },
                    //         //     ]
                    //         // },
                    //         {
                    //             label: 'Term Sheet', icon: '', routerLink: ['/credit/term-sheet'],
                    //             visible: this.menuGuardSrv.hideOrShow([
                    //                 'start credit application',
                    //             ])
                    //         },
                            {
                                label: 'Credit Appraisal', icon: '', routerLink: ['/credit/appraisal/credit-appraisal'],
                                visible: this.menuGuardSrv.hideOrShow(['credit appraisal'])
                            },
                    //         {
                    //             label: 'Committee Secretariat', icon: '', routerLink: ['/credit/loan/secretariat'],
                    //             visible: this.menuGuardSrv.hideOrShow(['committee secretariat'])
                    //         },
                            // {
                            //     label: 'Generate Offer Letter', icon: '', routerLink: ['/credit/loan/offer-letter'],
                            //     visible: this.menuGuardSrv.hideOrShow(['generate offer letter'])
                            // },
                            // {
                            //     label: 'Review Offer Letter', icon: '', routerLink: ['/credit/loan/offer-letter-review'],
                            //     visible: this.menuGuardSrv.hideOrShow(['review offer letter'])
                            // },
                            {
                                label: 'Availment', icon: '', routerLink: ['/credit/loan/availment'],
                                visible: this.menuGuardSrv.hideOrShow(['availment'])
                            },
                            {
                                label: 'DrawDown Request', icon: '', routerLink: ['/credit/loan/booking/initiate-booking'],
                                visible: this.menuGuardSrv.hideOrShow(['booking request'])
                            },
                    //         {
                    //             label: 'Bulk Disbursement Request', icon: '', routerLink: ['/credit/loan/booking/multiple-disbursement'],
                    //             visible: this.menuGuardSrv.hideOrShow(['booking request'])
                    //         },
                    //         {
                    //             label: 'Manual Fee', icon: '', routerLink: ['/credit/loan-management/take-fee'],
                    //             visible: this.menuGuardSrv.hideOrShow(['manual fee'])
                    //         },
                    //         {
                    //             label: 'Capture CRMS Code', icon: '', routerLink: ['/credit/loan/loan-crms-update'],
                    //             visible: this.menuGuardSrv.hideOrShow(['crms-user'])
                    //         },
                    //         {
                    //             label: 'Booking', icon: '', routerLink: ['/credit/loan/booking'],
                    //             visible: this.menuGuardSrv.hideOrShow(['booking'])
                    //         },
                    //         {
                    //             label: 'B&G Release', icon: '', routerLink: ['/credit/loan/contingent'],
                    //             visible: this.menuGuardSrv.hideOrShow(['bonds and guarantee'])
                    //         },

                    //         {
                    //             label: 'FX Account Setup', icon: '', routerLink: ['/setup/charge/fx-account-creation'],
                    //             visible: this.menuGuardSrv.hideOrShow(['booking'])
                    //         },


                    //         {
                    //             label: 'Confirm Collateral Search', icon: '', routerLink: ['/credit/legal-job-request-confirmation'],
                    //             visible: this.menuGuardSrv.hideOrShow(['confirm collateral search'])
                    //         },

                    //         {
                    //             label: 'Override Request', icon: '', routerLink: ['/credit/loan/override'],
                    //             visible: this.menuGuardSrv.hideOrShow(['override request'])
                    //         },

                    //         {
                    //             label: 'Completed Loan Confirmation', icon: '', routerLink: ['/credit/loan/completed-loan-confirmation'],
                    //             visible: this.menuGuardSrv.hideOrShow(['override request'])
                    //         },

                    //         {
                    //             label: 'Project Site Report', icon: '', routerLink: ['/credit/project-site-report'],
                    //             visible: this.menuGuardSrv.hideOrShow(['Project Site Report'])
                    //         },
                        ]
                     },
                    {
                        label: 'Credit Management', icon: '',
                        visible: this.menuGuardSrv.hideOrShow([
                            'lms application',
                            'lms appraisal',
                            'lms generate offer letter',
                            'lms availment',
                            'credit application status',
                            'loan operations',
                            'overdraft operations',
                            'recovery operations',
                            'contingent operations',
                            'loan operations',
                            'loan operations',
                            'recovery payment plan',
                            'manual fee',
                            'prepayment',
                            'aps request',
                            'application route',
                            'reassign account',
                            'collateral information',
                            'collateral assignment',
                            ' covenant maintenance',
                            'risk assessment',
                            'facility detail summary',
                            'credit classification',
                            'fee charge change',
                            'maturity instruction',
                            'commercial loan rollover',
                            'commercial loan tenor extension',
                            'commercial loan sub-allocation',
                            'commercial loan rate review',
                            'commercial loan prepayment',
                            'committee secretariat',
                            'schedule simulation',
                            'availmant route',
                            'collateral insurance request'
                            


                        ]),
                        items: [
                    //         {
                    //             label: 'Facility Detail Summary', icon: '', routerLink: ['/credit/loan/facility-detail-summary'],
                    //             visible: this.menuGuardSrv.hideOrShow(['facility detail summary'])
                    //         },
                            {
                                label: 'Application', icon: '', routerLink: ['/credit/loan-review-approval/application'],
                                visible: this.menuGuardSrv.hideOrShow(['lms application'])
                            },
                            {
                                label: 'Appraisal', icon: '', routerLink: ['/credit/loan-review-approval/appraisal'],
                                visible: this.menuGuardSrv.hideOrShow(['lms appraisal'])
                            },
                    //         {
                    //             label: 'Routing', icon: '',
                    //             visible: this.menuGuardSrv.hideOrShow([
                    //                 'application route',
                    //                 'availment route',
                    //                 'operation route',
                    //             ]),
                    //             items: [
                    //                 {
                    //                     label: 'Application Route', icon: '', routerLink: ['/credit/appraisal/sla-monitoring'],
                    //                     visible: this.menuGuardSrv.hideOrShow(['application route'])
                    //                 },
                    //                 {
                    //                     label: 'Operation Route', icon: '', routerLink: ['/credit/appraisal/operation-route'],
                    //                     visible: this.menuGuardSrv.hideOrShow(['operation route'])
                    //                 },
                    //                 {
                    //                     label: 'Availment Route', icon: '', routerLink: ['/credit/appraisal/availment-route'],
                    //                     visible: this.menuGuardSrv.hideOrShow(['availment route'])
                    //                 },
                    //             ]
                    //         },
                             {
                                label: 'Application Review Search', icon: '', routerLink: ['/credit/loan/loan-review-application-search'],
                                visible: this.menuGuardSrv.hideOrShow(['credit application status'])
                            },
                    //         {
                    //             label: 'Committee Secretariat', icon: '', routerLink: ['/credit/loan/secretariat'],
                    //             visible: this.menuGuardSrv.hideOrShow(['committee secretariat'])
                    //         },
                    //         {
                    //             label: 'Generate Offer Letter', icon: '', routerLink: ['/credit/loan-review-approval/offer-letter'],
                    //             visible: this.menuGuardSrv.hideOrShow(['lms generate offer letter'])
                    //         },
                            {
                                label: 'Availment', icon: '', routerLink: ['/credit/loan-review-approval/availment'],
                                visible: this.menuGuardSrv.hideOrShow(['lms availment'])
                            },
                    //         {
                    //             label: 'Line Operations', icon: '', routerLink: ['/credit/loan-management/facility-line-operations'],
                    //             visible: this.menuGuardSrv.hideOrShow(['facility-line-operations'])
                    //         },
                    //         {
                    //             label: 'Term Loan Operations', icon: '', routerLink: ['/credit/loan-management/loan-review-operation'],
                    //             visible: this.menuGuardSrv.hideOrShow(['loan operations'])
                    //         },
                    //         {
                    //             label: 'Commercial Loan Operations', icon: '', routerLink: ['/credit/loan-management/commercial-loan-operations'],
                    //             visible: this.menuGuardSrv.hideOrShow(['loan operations'])
                    //         },
                    //         // {
                    //         //     label: 'FX Revolving Loan Operations', icon: '', routerLink: ['/credit/loan-management/fx-revolving-loan-operations'],
                    //         //     visible: this.menuGuardSrv.hideOrShow(['fx revolving loan operations'])
                    //         // },
                    //         {
                    //             label: 'Overdraft Operations', icon: '', routerLink: ['/credit/loan-management/overdraft-operations'],
                    //             visible: this.menuGuardSrv.hideOrShow(['overdraft operations'])
                    //         },
                    //         {
                    //             label: 'Recovery Operations', icon: '', routerLink: ['/credit/loan-management/remedial-opreation'],
                    //             visible: this.menuGuardSrv.hideOrShow(['recovery operations'])
                    //         },
                    //         {
                    //             label: 'Loan Recovery Payment', icon: '', routerLink: ['/credit/loan-management/app-loan-recovery-payment'],
                    //             visible: this.menuGuardSrv.hideOrShow(['aps request'])
                    //         },
                    //         {
                    //             label: 'Contingent Liability', icon: '',
                    //             visible: this.menuGuardSrv.hideOrShow([
                    //                 'contingent operations',
                    //             ]),
                    //             items: [
                    //                 {
                    //                     label: 'Contingent Appraisal Operations', icon: '', routerLink: ['/credit/loan-management/contingent-operations'],
                    //                     visible: this.menuGuardSrv.hideOrShow(['contingent operations'])
                    //                 },
                    //                 {
                    //                     label: 'Contingent Operations', icon: '', routerLink: ['/credit/loan-management/contingent-liability-terminate-rebook'],
                    //                     visible: this.menuGuardSrv.hideOrShow(['contingent operations'])
                    //                 },
                    //                 {
                    //                     label: 'Expired Contingents', icon: '', routerLink: ['/credit/loan-management/contingent-termination'],
                    //                     visible: this.menuGuardSrv.hideOrShow(['contingent operations'])
                    //                 },
                    //                 {
                    //                     label: 'Cancel In-Active Contingents', icon: '', routerLink: ['/credit/loan-management/cancel-contingent-liability'],
                    //                     visible: this.menuGuardSrv.hideOrShow(['contingent operations'])
                    //                 },
                    //             ]
                    //         },
                    //         {
                    //             label: 'Manual Fee', icon: '', routerLink: ['/credit/loan-management/take-fee'],
                    //             visible: this.menuGuardSrv.hideOrShow(['manual fee'])
                    //         },
                    //         {
                    //             label: 'Global Interest Rate Change', icon: '', routerLink: ['/credit/loan-management/global-interest-rate-change'],
                    //             visible: this.menuGuardSrv.hideOrShow(['global interest rate change'])
                    //         },
                    //         // {
                    //         //     label: 'Recovery Payment Plan', icon: '', routerLink: ['/credit/loan-management/LoanRecoveryPaymentPlan'],
                    //         //     visible: this.menuGuardSrv.hideOrShow(['recovery payment plan'])
                    //         // },
                    //         {
                    //             label: 'Prepayment', icon: '', routerLink: ['/credit/loan-management/loan-prepayment'],
                    //             visible: this.menuGuardSrv.hideOrShow(['prepayment'])
                    //         },
                    //         {
                    //             label: 'Loan Termination', icon: '', routerLink: ['/credit/loan-management/loan-termination'],
                    //             visible: this.menuGuardSrv.hideOrShow(['termination'])
                    //         },
                    //         // {
                    //         //     label: 'CP/FX Loan Prepayment', icon: '', routerLink: ['/credit/loan-management/commercial-loans/cp-prepayment'],
                    //         //     visible: this.menuGuardSrv.hideOrShow(['commercial loan prepayment'])
                    //         // },
                    //         {
                    //             label: 'Loan Fee Adjustment', icon: '', routerLink: ['/credit/loan-management/loan-fee-adjustment'],
                    //             visible: this.menuGuardSrv.hideOrShow(['loan operations'])
                    //         },
                    //         {
                    //             label: 'Loan Classification', icon: '', routerLink: ['/credit/loan-management/loan-performance'],
                    //             visible: this.menuGuardSrv.hideOrShow(['loan operations'])
                    //         },
                    //         {
                    //             label: 'APS Request', icon: '', routerLink: ['/credit/loan/contingent-usage-list'],
                    //             visible: this.menuGuardSrv.hideOrShow(['aps request'])
                    //         },
                    //         {
                    //             label: 'Reassign Account', icon: '', routerLink: ['/credit/loan/reassign-account'],
                    //             visible: this.menuGuardSrv.hideOrShow(['reassign account'])
                    //         },
                            

                    //         {
                    //             label: ' Covenant Maintenance', icon: '', routerLink: ['/credit/loan-covenant/covenant-detail'],
                    //             visible: this.menuGuardSrv.hideOrShow([' covenant maintenance'])
                    //         },
                    //         {
                    //             label: 'Risk Assessment', icon: '', routerLink: ['/credit/risk/risk-assessment'],
                    //             visible: this.menuGuardSrv.hideOrShow(['risk assessment'])
                    //         },
                    //         {
                    //             label: 'Facility Line Information', icon: '', routerLink: ['/credit/loan/facility-details/tranche-facility-utilization'],
                    //             visible: this.menuGuardSrv.hideOrShow(['booking request'])
                    //         }, {
                    //             label: 'Completed Loan Confirmation', icon: '', routerLink: ['/credit/loan/completed-loan-confirmation'],
                    //             visible: this.menuGuardSrv.hideOrShow(['override request'])
                    //         },


                    //         {
                    //             label: 'Full And Final Complete Write-off', icon: '', routerLink: ['/credit/loan/full-and-final-status-change'],
                    //             visible: this.menuGuardSrv.hideOrShow(['full and final writeoff'])
                    //         }


                    //         // {
                    //         //     label: 'Commercial Loans', icon: '',
                    //         //     visible: this.menuGuardSrv.hideOrShow([
                    //         //         'maturity instruction',
                    //         //         'commercial loan rollover',
                    //         //         'commercial loan tenor extension',
                    //         //         'commercial loan sub-allocation',
                    //         //         'commercial loan rate review',
                    //         //         'commercial loan prepayment',
                    //         //     ]),
                    //         //     items: [
                    //         //         {
                    //         //             label: 'Maturity Instruction', icon: '', routerLink: ['/credit/loan-management/commercial-loans/maturity-instruction'],
                    //         //             visible: this.menuGuardSrv.hideOrShow(['maturity instruction'])
                    //         //         },
                    //         //         {
                    //         //             label: 'Rollover', icon: '', routerLink: ['/credit/loan-management/commercial-loans/cp-rollover'],
                    //         //             visible: this.menuGuardSrv.hideOrShow(['commercial loan rollover'])
                    //         //         },
                    //         //         {
                    //         //             label: 'Tenor Extension', icon: '', routerLink: ['/credit/loan-management/commercial-loans/cp-tenor-extension'],
                    //         //             visible: this.menuGuardSrv.hideOrShow(['commercial loan tenor extension'])
                    //         //         },
                    //         //         {
                    //         //             label: 'Rate Review', icon: '', routerLink: ['/credit/loan-management/commercial-loans/cp-interest-rate-review'],
                    //         //             visible: this.menuGuardSrv.hideOrShow(['commercial loan rate review'])
                    //         //         },
                    //         //         {
                    //         //             label: 'Sub-Allocation', icon: '', routerLink: ['/credit/loan-management/commercial-loans/cp-sub-allocation'],
                    //         //             visible: this.menuGuardSrv.hideOrShow(['commercial loan sub-allocation'])
                    //         //         },
                    //         //         {
                    //         //             label: 'Loan Prepayment', icon: '', routerLink: ['/credit/loan-management/commercial-loans/cp-prepayment'],
                    //         //             visible: this.menuGuardSrv.hideOrShow(['commercial loan prepayment'])
                    //         //         },
                    //         //     ]
                    //         // },
                    //         // {
                    //         //     label: 'Credit Classification', icon: '', routerLink: ['#'],
                    //         //     visible: this.menuGuardSrv.hideOrShow(['credit classification'])
                    //         // },
                    //         // {
                    //         //     label: 'Fee Charge Change', icon: '', routerLink: ['#'],
                    //         //     visible: this.menuGuardSrv.hideOrShow(['fee charge change'])
                    //         // },
                        ]
                    },
                    {
                        label: 'Collateral', icon: '',
                        visible: this.menuGuardSrv.hideOrShow([
                            'collateral information',
                            'collateral assignment',
                            'collateral insurance request',
                            'collateral policy approval',
                            'collateral swap'
                        ]),
                        items: [
                    //         {
                    //             label: 'Collateral Information', icon: '', routerLink: ['/credit/collateral/collateral-information'],
                    //             visible: this.menuGuardSrv.hideOrShow(['collateral information'])
                    //         },
                    //         {
                    //             label: 'Collateral Information Release', icon: '', routerLink: ['/credit/collateral/collateral-information-release'],
                    //             visible: this.menuGuardSrv.hideOrShow(['collateral information'])
                    //         },
                    //         {
                    //             label: 'Collateral Release Job Request', icon: '', routerLink: ['/credit/collateral/collateral-release-awaiting-job-request'],
                    //             visible: this.menuGuardSrv.hideOrShow(['collateral information'])
                    //         },
                    //         {
                    //             label: 'Collateral Release', icon: '', routerLink: ['/credit/collateral/collateral-assignment'],
                    //             visible: this.menuGuardSrv.hideOrShow(['collateral assignment'])
                    //         },
                    //         {
                    //             label: 'Collateral Valuation', icon: '', routerLink: ['/credit/loan/collateral-valuation'],
                    //             visible: this.menuGuardSrv.hideOrShow(['collateral valuation'])
                    //         },
                    //         {
                    //             label: 'Collateral Insurance Request', icon: '', routerLink: ['/credit/loan/collateral-insurance-request'],
                    //             visible: this.menuGuardSrv.hideOrShow(['collateral insurance request'])
                    //         },
                    //         {
                    //             label: 'Collateral Insurance Search', icon: '', routerLink: ['/credit/loan/collateral-insurance-search'],
                    //             visible: this.menuGuardSrv.hideOrShow(['collateral insurance request',
                    //                                                     'collateral policy approval'])
                    //         },
                    //     ]
                    // },
                    // {
                    //     label: 'Original Document Submission', icon: '', routerLink: ['/credit/loan/original-document-submission'],
                    //     visible: this.menuGuardSrv.hideOrShow(['Original Document'])
                    // },
                    // {
                    //     label: 'Security Release', icon: '', routerLink: ['/credit/loan/security-release'],
                    //     visible: this.menuGuardSrv.hideOrShow(['security release'])
                    // },
                    {
                        label: 'Call Memo', icon: '', routerLink: ['/credit/loan/call-memo'],
                        visible: this.menuGuardSrv.hideOrShow(['call memo'])
                    },
                    // {
                    //     label: 'Written-off Accounts/Black-Book', icon: '', routerLink: ['/credit/risk/loan-camsol'],
                    //     visible: this.menuGuardSrv.hideOrShow(['risk assessment'])
                    // },
                    // {
                    //     label: 'Deferral Management ', icon: '', routerLink: ['/credit/loan/application/deferral-management'],
                    //     visible: this.menuGuardSrv.hideOrShow(['deferral management'])
                    // },
                    // {
                    //     label: 'Repayment Schedule Simulation', icon: '', routerLink: ['/credit/loan/schedule'],
                    //     visible: this.menuGuardSrv.hideOrShow(['schedule simulation'])
                    // },
                ]
            },
            // {
            //     label: 'Reports', icon: 'timeline',
            //     visible: this.menuGuardSrv.hideOrShow([
            //         'repayment schedule',
            //         'disbursement',
            //         'disbursal credit turnover',
            //         'statement',
            //         'anniversary',
            //         'waivers',
            //         'deferred',
            //         'waived',
            //         'deferrals',
            //         'deferrals for mcc',
            //         'scheduled fcy credit',
            //         'collateral report',
            //         'workflow definition report',
            //         'workflow sla report',
            //         'posted transaction report',
            //         'branch npl limit report',
            //         'sectorial limit report',
            //         'collateral revaluation report',
            //         'covenant report',
            //         'npl report',
            //         'expired overdraft report',
            //         'expired fts report',
                   
            //     ]),
            //     items: [

            //         {
            //             label: 'Audit Trail', icon: '', visible: this.menuGuardSrv.hideOrShow([
            //                 'audit trail report'
            //             ]),
            //             items: [
            //                 {
            //                     label: 'System Audit Trail', icon: '', routerLink: ['/report/admin/audit-trail-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['audit trail report'])
            //                 },
            //                 {
            //                     label: 'Logging Status', icon: '', routerLink: ['/report/admin/logging-status'],
            //                     visible: this.menuGuardSrv.hideOrShow(['audit trail report'])
            //                 },
            //                 {
            //                     label: 'Staff Privilege Change', icon: '', routerLink: ['/report/staff/staff-privilege-change'],
            //                     visible: this.menuGuardSrv.hideOrShow(['audit trail report'])
            //                 },
            //                 {
            //                     label: 'User Group Change', icon: '', routerLink: ['/report/staff/user-group-change-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['audit trail report'])
            //                 },
            //                 {
            //                     label: 'Profile Activity', icon: '', routerLink: ['/report/staff/profile-activity-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['audit trail report'])
            //                 },
            //                 {
            //                     label: 'Staff Role Profile Group', icon: '', routerLink: ['/report/staff/staff-role-profile-group-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['audit trail report'])
            //                 },
            //                 {
            //                     label: 'Staff Role Profile Activity', icon: '', routerLink: ['/report/staff/staff-role-profile-activity-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['audit trail report'])
            //                 }
                            
            //             ]
            //         },
            //         {
            //             label: 'Credit', icon: '', visible: this.menuGuardSrv.hideOrShow([
            //                 'repayment schedule',
            //                 'disbursement',
            //                 'statement',
            //                 'anniversary',
            //                 'waivers',
            //                 'deferred',
            //                 'waived',
            //                 'deferrals',
            //                 'deferrals for mcc',
            //                 'scheduled fcy credit',
            //                 'collateral report',
                        
            //             ]),
            //             items: [
            //                 {
            //                     label: 'Repayment Schedule', icon: '', routerLink: ['/report/loan-details/loan-schedule'],
            //                     visible: this.menuGuardSrv.hideOrShow(['repayment schedule'])
            //                 },
            //                 {
            //                     label: 'Disbursement', icon: '', routerLink: ['/report/loan-details/loan-disburstment'],
            //                     visible: this.menuGuardSrv.hideOrShow(['disbursement'])
            //                 },

            //                 {
            //                     label: 'Running Facilities', icon: '', routerLink: ['/report/loan-details/running-facilities'],
            //                     visible: this.menuGuardSrv.hideOrShow(['running facilities'])
            //                 },

            //                 {
            //                     label: 'Middle Office', icon: '', routerLink: ['/report/loan-details/middle-office-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['middle office report'])
            //                 },
            //                 {
            //                     label: 'Collateral Valuation', icon: '', routerLink: ['/report/loan-details/collateral-valuation-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral valuation report'])
            //                 },
            //                 {
            //                     label: 'Credit Schedule', icon: '', routerLink: ['/report/loan-details/credit-schedule-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['credit schedule report'])
            //                 },

            //                 {
            //                     label: 'In Active Contigent Liability', icon: '', routerLink: ['/report/loan-details/in-active-contigent-liability-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['inActive Contigent Liability'])
            //                 },
            //                 {
            //                     label: 'Loan Statement', icon: '', routerLink: ['/report/loan/loan-statement'],
            //                     visible: this.menuGuardSrv.hideOrShow(['statement'])
            //                 },
            //                 {
            //                     label: 'Disbursal Credit Turnover', icon: '', routerLink: ['/report/loan/disbursal-credit-turnover'],
            //                     visible: this.menuGuardSrv.hideOrShow(['statement'])
            //                 },
            //                 {
            //                     label: 'Anniversary', icon: '', routerLink: ['/report/loan/loan-LoanAnniversery'],
            //                     visible: this.menuGuardSrv.hideOrShow(['anniversary'])
            //                 },
            //                 {
            //                     label: 'Waivers', icon: '', routerLink: ['/report/loan/loan-document-waived'],
            //                     visible: this.menuGuardSrv.hideOrShow(['waived'])
            //                 },
            //                 {
            //                     label: 'Deferals', icon: '', routerLink: ['/report/loan/loan-document-deferred'],
            //                     visible: this.menuGuardSrv.hideOrShow(['deferred'])
            //                 },
            //                 //  {
            //                 // label: 'Deferrals', icon: '', routerLink: ['/report/loan/loan-deferral'],
            //                 //visible: this.menuGuardSrv.hideOrShow(['deferrals'])
            //                 //},
            //                 {
            //                     label: 'Deferrals For MCC', icon: '', routerLink: ['/report/loan/loan-deferral-mcc'],
            //                     visible: this.menuGuardSrv.hideOrShow(['deferrals for mcc'])
            //                 },
            //                 {
            //                     label: 'Scheduled FCY Credit', icon: '', routerLink: ['/report/loan/loan-fcyscheuled'],
            //                     visible: this.menuGuardSrv.hideOrShow(['scheduled fcy credit'])
            //                 },
            //                 {
            //                     label: 'Collateral', icon: '', routerLink: ['/report/loan/collateral-estimated'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },

            //                 {
            //                     label: 'Booking Report', icon: '', routerLink: ['/report/loan/loan-booking-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },
            //                 {
            //                     label: 'Form300b-Facilities', icon: '', routerLink: ['/report/loan/form300b-facility-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },
            //                 {
            //                     label: 'Submission of Original Document', icon: '', routerLink: ['/report/loan/original-document-submission'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },
            //                 {
            //                     label: 'Risk Assets Report', icon: '', routerLink: ['/report/risk-assets-report/risk-assets-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },
            //                 {
            //                     label: 'Contigent Report', icon: '', routerLink: ['/report/contigent-report/contigent-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },
            //                 {
            //                     label: 'Expired Facility report', icon: '', routerLink: ['/report/expired-Facility-report/expired-Facility-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },
            //                 {
            //                     label: 'Large Exposure report', icon: '', routerLink: ['/report/large-exposure-report/large-exposure-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },
            //                 {
            //                     label: 'Overline Report', icon: '', routerLink: ['/report/overline-report/overline-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },
            //                 {
            //                     label: 'Extension Report', icon: '', routerLink: ['/report/extension-report/extension-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },
            //                 {
            //                     label: 'Maturity Report', icon: '', routerLink: ['/report/maturity-report/maturity-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },
            //                 {
            //                     label: 'Unpaid Obligation Report', icon: '', routerLink: ['/report/unpaid-obligation-report/unpaid-obligation-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },
            //                 {
            //                     label: 'Risk Asset Team Report', icon: '', routerLink: ['/report/risk-asset-team-report/risk-asset-team-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },
            //                 {
            //                     label: 'Risk Asset Main Report', icon: '', routerLink: ['/report/risk-asset-main-report/risk-asset-main-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },
            //                 {
            //                     label: 'Risk Asset By Variance Report', icon: '', routerLink: ['/report/risk-asset-by-variance-report/risk-asset-by-variance-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },
            //                 {
            //                     label: 'Risk Asset Distribution By Sector Report', icon: '', routerLink: ['/report/risk-asset-distribution-by-sector-report/risk-asset-distribution-by-sector-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },
            //                 {
            //                     label: 'Risk Asset By IFRS Classification Report', icon: '', routerLink: ['/report/risk-asset-by-ifrs-classification-report/risk-asset-by-ifrs-classification-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 },
            //                 {
            //                     label: 'IFRS Classification Team Report', icon: '', routerLink: ['/report/ifrs-classification-team-report/ifrs-classification-team-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral report'])
            //                 }
            //             ]
            //         },
            //         {
            //             label: 'Approval Workflow', icon: '', visible: this.menuGuardSrv.hideOrShow([
            //                 'workflow definition report',
            //                 'workflow sla report',
            //             ]),
            //             items: [
            //                 {
            //                     label: 'Workflow Definition', icon: '', routerLink: ['/report/Workflow/definition'],
            //                     visible: this.menuGuardSrv.hideOrShow(['workflow definition report'])
            //                 },
            //                 {
            //                     label: 'Workflow SLA', icon: '', routerLink: ['/report/loan-workflow/application-sla'],
            //                     visible: this.menuGuardSrv.hideOrShow(['workflow sla report'])
            //                 },
            //                 {
            //                     label: 'SLA Monitoring', icon: '', routerLink: ['/report/loan-workflow/sla-monitoring'],
            //                     visible: this.menuGuardSrv.hideOrShow(['workflow sla report'])
            //                 }
            //             ]
            //         },
            //         {
            //             label: 'LOS CRMS Regulatory', icon: '', routerLink: ['/credit/newloan/crms'],
            //             visible: this.menuGuardSrv.hideOrShow(['start credit application'])
            //         },
            //         {
            //             label: 'LMS CRMS Regulatory', icon: '', routerLink: ['/credit/newloan/lms-crms'],
            //             visible: this.menuGuardSrv.hideOrShow(['start credit application'])
            //         },
            //         {
            //             label: 'Posted Transaction', icon: '', routerLink: ['/report/finance/posted-transaction'],
            //             visible: this.menuGuardSrv.hideOrShow(['posted transaction report'])
            //         },
            //         {
            //             label: 'Daily Interest Accrual', icon: '', routerLink: ['/report/finance/daily-interest-accrual'],
            //             visible: this.menuGuardSrv.hideOrShow(['posted transaction report'])
            //         },
            //         {
            //             label: 'Loan Repayment', icon: '', routerLink: ['/report/finance/loan-repayment'],
            //             visible: this.menuGuardSrv.hideOrShow(['posted transaction report'])
            //         },
            //         {
            //             label: 'Custom Facility Repayment', icon: '', routerLink: ['/report/finance/custom-factility-repayment'],
            //             visible: this.menuGuardSrv.hideOrShow(['posted transaction report'])
            //         },
            //         {
            //             label: 'Monitoring', icon: '', visible: this.menuGuardSrv.hideOrShow([
            //                 'branch npl limit report',
            //                 'sectorial limit report',
            //                 'collateral revaluation report',
            //                 'covenant report',
            //                 'npl report',
            //                 'expired overdraft report',
            //                 'expired fts report',
            //             ]),
            //             items: [
            //                 {
            //                     label: 'Branch NPL', icon: '', routerLink: ['/report/loan-Limit-monitoring/branch-limit'],
            //                     visible: this.menuGuardSrv.hideOrShow(['branch npl limit report'])
            //                 },
            //                 {
            //                     label: 'Sector Limit', icon: '', routerLink: ['/report/loan-Limit-monitoring/sectorial-limit'],
            //                     visible: this.menuGuardSrv.hideOrShow(['sectorial limit report'])
            //                 },
            //                 {
            //                     label: 'Collateral Revaluation', icon: '',
            //                     routerLink: ['/report/loan-monitoring/collateral-property-revaluation'],
            //                     visible: this.menuGuardSrv.hideOrShow(['collateral revaluation report'])
            //                 },
            //                 {
            //                     label: 'Covenants', icon: '', routerLink: ['/report/loan-monitoring/almost-due-covenants'],
            //                     visible: this.menuGuardSrv.hideOrShow(['covenant report'])
            //                 },
            //                 {
            //                     label: 'NPL', icon: '', routerLink: ['/report/loan-monitoring/non-performing-loans'],
            //                     visible: this.menuGuardSrv.hideOrShow(['npl report'])
            //                 },
            //                 {
            //                     label: 'Expired Overdraft', icon: '',
            //                     routerLink: ['/report/loan-monitoring/expired-overdraft-loans'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired overdraft report'])
            //                 },
            //                 {
            //                     label: 'Expired FTS', icon: '',
            //                     routerLink: ['/report/loan/expired-stakeholder-with-pnd'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Bonds & Guarantee', icon: '',
            //                     routerLink: ['/report/loan/bond-and-guarantee'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Collateral Due For Visitation', icon: '',
            //                     routerLink: ['/report/loan/collateral-visitation'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Expired Collateral Insurance', icon: '',
            //                     routerLink: ['/report/loan/insurance-expiration'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Turnover Covenant', icon: '',
            //                     routerLink: ['/report/loan/turnover-covenant'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Self Liquidating Loan', icon: '',
            //                     routerLink: ['/report/loan/expired-self-liquidating-loans'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Blacklist', icon: '',
            //                     routerLink: ['/report/loan/blacklist'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Lien', icon: '',
            //                     routerLink: ['/report/loan/lien'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Stalled Perfection For Collaterals', icon: '',
            //                     routerLink: ['/report/loan/stalled-perfection-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Collateral Perfection Yet to Commence', icon: '',
            //                     routerLink: ['/report/loan/collateral-perfection-yettocommence'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'All Commercial Loan Report', icon: '',
            //                     routerLink: ['/report/loan/all-comercial-loan-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Loan Classification Report', icon: '',
            //                     routerLink: ['/report/loan/loan-classification-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Age Analysis Report', icon: '',
            //                     routerLink: ['/report/loan/age-analysis-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },

            //                 {
            //                     label: 'Runining Loan Report', icon: '',
            //                     routerLink: ['/report/loan/runining-loan-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },

            //                 {
            //                     label: 'Impaired WatchList Report', icon: '',
            //                     routerLink: ['/report/loan/impaired-watch-list-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Insurance Report', icon: '',
            //                     routerLink: ['/report/loan/insurance-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Excess Report', icon: '',
            //                     routerLink: ['/report/loan/excess-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Unutilized Facility Report', icon: '',
            //                     routerLink: ['/report/loan/unutilized-facility-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },

            //                 {
            //                     label: 'Expired Report', icon: '',
            //                     routerLink: ['/report/loan/expired-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Sanction Limit Report', icon: '',
            //                     routerLink: ['/report/loan/sanction-limit-report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },

            //                 {
            //                     label: 'Unearned and Receivable Interest Report', icon: '',
            //                     routerLink: ['/report/loan/unearned-interest-Report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'CashBacked Facility For OD And Loans Report', icon: '',
            //                     routerLink: ['/report/loan/cashbacked-Report'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },

            //                 {
            //                     label: 'CashBack Bond Guarantee', icon: '',
            //                     routerLink: ['/report/loan/cashbacked-bond-guarantee'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Weekly Recovery Report FINCON', icon: '',
            //                     routerLink: ['/report/loan/weeklyrecovery-Reportfor-FINCON'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 },
            //                 {
            //                     label: 'Cash Collaterized Credits', icon: '',
            //                     routerLink: ['/report/loan/cash-collaterized-credits'],
            //                     visible: this.menuGuardSrv.hideOrShow(['expired fts report'])
            //                 }

            //             ]
            //         },

                ]
             }

        ];

    }

    changeTheme(theme) {
        const themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('theme-css');
        const layoutLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('layout-css');
        themeLink.href = 'assets/theme/theme-' + theme + '.css';
        layoutLink.href = 'assets/layout/css/layout-' + theme + '.css';
    }
}

@Component({
    selector: '[app-submenu]',
    template: `
        <ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
            <li [ngClass]="{'active-menuitem': isActive(i)}" *ngIf="child.visible === false ? false : true">
                <a [href]="child.url||'#'" (click)="itemClick($event,child,i)" class="ripplelink" *ngIf="!child.routerLink" [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target">
                    <i class="material-icons">{{child.icon}}</i>
                    <span>{{child.label}}</span>
                    <i class="material-icons" *ngIf="child.items">keyboard_arrow_down</i>
                </a>

                <a (click)="itemClick($event,child,i)" class="ripplelink" *ngIf="child.routerLink"
                    [routerLink]="child.routerLink" routerLinkActive="active-menuitem-routerlink" [routerLinkActiveOptions]="{exact: true}" [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target">
                    <i class="material-icons">{{child.icon}}</i>
                    <span>{{child.label}}</span>
                    <i class="material-icons" *ngIf="child.items">keyboard_arrow_down</i>
                </a>
                <ul app-submenu [item]="child" *ngIf="child.items" [@children]="isActive(i) ? 'visible' : 'hidden'" [visible]="isActive(i)" [reset]="reset"></ul>
            </li>
        </ng-template>
    `,
    animations: [
        trigger('children', [
            state('hidden', style({
                height: '0px'
            })),
            state('visible', style({
                height: '*'
            })),
            transition('visible => hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hidden => visible', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})

export class AppSubMenuComponent {

    @Input() item: MenuItem;

    @Input() root: boolean;

    @Input() visible: boolean;

    _reset: boolean;

    activeIndex: number;

    constructor(@Inject(forwardRef(() => MainLayoutComponent)) public app: MainLayoutComponent,
        public router: Router, public location: Location) { }

    itemClick(event: Event, item: MenuItem, index: number) {
        // avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        // activate current item and deactivate active sibling if any
        this.activeIndex = (this.activeIndex === index) ? null : index;

        // execute command
        /*    if (item.command) {
               if (!item.eventEmitter) {
                   item.eventEmitter = new EventEmitter();
                   item.eventEmitter.subscribe(item.command);
               }
   
               item.eventEmitter.emit({
                   originalEvent: event,
                   item: item
               });
           } */

        // prevent hash change
        if (item.items || (!item.url && !item.routerLink)) {
            event.preventDefault();
        }

        // hide menu
        if (!item.items) {
            if (this.app.isHorizontal()) {
                this.app.resetMenu = true;
            } else {
                this.app.resetMenu = false;
            }
            this.app.overlayMenuActive = false;
            this.app.staticMenuMobileActive = false;
        }
    }
    isActive(index: number): boolean {
        return this.activeIndex === index;
    }

    @Input() get reset(): boolean {
        return this._reset;
    }

    set reset(val: boolean) {
        this._reset = val;

        if (this._reset && this.app.isHorizontal()) {
            this.activeIndex = null;
        }
    }
}

/*
{
    label: '_LABEL_', icon: '', routerLink: ['#'],
    visible: this.menuGuardSrv.hideOrShow(['_ACTIVITY_'])
},*/